/**
 * @param {string} type
 * @param {string} url
 * @returns {string | null}
 */
export function normalizeSecondaryHref(type, url) {
  if (!url || typeof url !== "string") {
    return null;
  }

  const trimmed = url.trim();
  if (!trimmed) {
    return null;
  }

  const t = type || "website";

  if (t === "call") {
    if (trimmed.startsWith("tel:")) {
      return trimmed;
    }
    const digits = trimmed.replace(/\D/g, "");
    return digits ? `tel:+${digits}` : null;
  }

  if (trimmed.startsWith("tel:") || trimmed.startsWith("mailto:")) {
    return trimmed;
  }

  try {
    const parsed = new URL(trimmed);
    if (parsed.protocol === "http:" || parsed.protocol === "https:") {
      return trimmed;
    }
    return null;
  } catch {
    return null;
  }
}

/**
 * @param {unknown} raw
 * @returns {Array<{ id: string, label: string, href: string, type: string }>}
 */
export function normalizeSecondaryButtons(raw) {
  if (!Array.isArray(raw)) {
    return [];
  }

  return raw
    .map((b, index) => ({ b, index }))
    .filter(
      ({ b }) =>
        b &&
        b.active !== false &&
        typeof b.url === "string" &&
        b.url.trim().length > 0,
    )
    .map(({ b, index }) => {
      const href = normalizeSecondaryHref(b.type, b.url);
      if (!href) {
        return null;
      }
      const sortOrder =
        typeof b.sort_order === "number" && !Number.isNaN(b.sort_order)
          ? b.sort_order
          : index;
      return {
        id: String(b.id ?? `secondary-${index}`),
        label: String(b.label || "Link"),
        href,
        type: String(b.type || "website"),
        sortOrder,
      };
    })
    .filter(Boolean)
    .sort((a, b) => a.sortOrder - b.sortOrder)
    .map(({ id, label, href, type }) => ({ id, label, href, type }));
}
